import { Collapse } from '@material-ui/core';
import { ReactNode } from 'react';
import { Loading } from '../Loading';
import { ResponseMessage } from '../ResponseMessage';

interface ModalActionHandlerProps {
  children: ReactNode;
  isLoading: boolean;
  isToast: boolean;
  loadingMessage: string;
  message: string;
  messagePopped: boolean;
  responseType: 'error' | 'success';
  showLoading: boolean;
  subMessage?: string;
}

export const ModalActionHandler = ({
  children,
  isLoading,
  isToast,
  loadingMessage,
  message,
  messagePopped,
  responseType,
  showLoading,
  subMessage,
}: ModalActionHandlerProps) => {
  const renderResponseMessage = () => {
    return (
      <ResponseMessage
        responseType={responseType}
        message={message}
        subMessage={subMessage}
        isToast={isToast}
      />
    );
  };

  if (messagePopped && !isToast) return renderResponseMessage();

  return (
    <>
      <div className="absolute flex justify-center bg-background-light dark:bg-background-dark w-full z-[1]">
        <Collapse in={messagePopped}>{renderResponseMessage()}</Collapse>
      </div>

      {showLoading && isLoading ? (
        <div className="absolute flex items-center justify-center w-full h-full rounded-b bg-card-light dark:bg-card-dark shadow">
          <Loading text={loadingMessage} />
        </div>
      ) : null}

      {children}
    </>
  );
};
